/*@flow*/
import React from 'react';
import Item from './Item';
import Textbox from 'lib/proforma/templates/Textbox';

type PropsT = { children: React$Node, label: React$Node };

export default (Textbox.clone({
  Label: () => null,
  FormGroup: ({ children, ...locals }: PropsT) => <Item label={locals.label}>{children}</Item>,
  Input: (props: { attrs: {}, placeholder: string }) => (
      <input
        {...props.attrs}
        placeholder={props.placeholder}
        className="form-control text-control"
      />
    ),
}): any);
